import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react";

// Local Components
import AffiliateProductsTab from "./AffiliateTab";
import NomaroiProductsTab from "./NomaroiTab";

const Products = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  //meta title
  document.title = `${props.t("Products")} | ${process.env.REACT_APP_CMS_TITLE}`;

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam === "nomaroi") {
      setSelectedIndex(1);
    } else {
      setSelectedIndex(0);
    }
  }, [location.search]);

  const handleTabChange = (index) => {
    setSelectedIndex(index);
    let tabValue = "affiliate";
    if (index === 1) tabValue = "nomaroi";

    navigate(`/products?tab=${tabValue}`);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={props.t("Products")} breadcrumbItem={props.t("จัดการสินค้า")} />
        {/* Add your products management content here */}
        <div className="d-flex flex-column gap-4">
          <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
            <TabList>
              <Tab data-testid="affiliate-tab">สินค้า Affiliate</Tab>
              <Tab data-testid="nomaroi-tab">สินค้าจาก Nomaroi</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <AffiliateProductsTab />
              </TabPanel>
              <TabPanel>
                <NomaroiProductsTab />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </div>
      </Container>
    </div>
  );
};

export default withTranslation()(Products);
